// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__1uCmx","errorLogs":"styles_errorLogs__3gCI6"};